export default "__VITE_ASSET__LdgVm0xM__"